import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { Ripple } from "@progress/kendo-react-ripple";

type loadingType = "pulsing" | "infinite-spinner" | "converging-spinner";
type Size = "small" | "medium" | "large";
type fillMode = "solid" | "outline" | "flat" | "link";
type Type = "submit" | "button" | "reset";
type themeColor =
  | "primary"
  | "base"
  | "secondary"
  | "tertiary"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "dark"
  | "light"
  | "inverse";

interface ILoadingButtonProps {
  label: string;
  loading?: boolean;
  disabled?: boolean;
  loadingType?: loadingType;
  Size?: Size;
  loadingSize?: Size;
  color?: string;
  fillMode?: fillMode;
  type?: Type;
  width?: string;
  themeColor?: themeColor;
  className?: string;
}

const ButtonWithLoading: React.FC<ILoadingButtonProps> = ({
  label,
  loading = false,
  disabled = false,
  loadingType = "pulsing",
  Size = "medium",
  loadingSize = "small",
  color = "white",
  fillMode = "solid",
  themeColor = "primary",
  type = "button",
  width = "fit-content",
  className = "",
}) => {
  return (
    <Ripple>
      <Button
        type={type}
        fillMode={fillMode}
        size={Size}
        style={{ width: width }}
        themeColor={themeColor}
        disabled={disabled}
        className={className}
      >
        {!loading ? (
          label
        ) : (
          <Loader style={{ color: color }} size={loadingSize} type={loadingType} />
        )}
      </Button>
    </Ripple>
  );
};

export default ButtonWithLoading;
